function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M248 400h16v64h-16zM248 48h16v64h-16zM48 248h64v16H48zM400 248h64v16h-64z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M148.452 352.163l11.313 11.314-45.254 45.254-11.313-11.312zM397.49 103.262l11.313 11.313-45.255 45.255-11.313-11.314z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M159.905 148.52l-11.314 11.313-45.253-45.254 11.313-11.315zM408.67 397.42l-11.313 11.315-45.255-45.255 11.314-11.313z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96z"
});

function SvgIosSunny({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosSunny);
export default __webpack_public_path__ + "static/media/ios-sunny.e2add9e1.svg";
export { ForwardRef as ReactComponent };